import { render } from "./PositionManagement.vue?vue&type=template&id=a95f18f6"
import script from "./PositionManagement.vue?vue&type=script&lang=js"
export * from "./PositionManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__